export default "__VITE_ASSET__BHmPVPXc__"